module.exports = __webpack_public_path__ + "static/img/1441_phase_function_Paper_Points.9d20857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1441_phase_function_Paper_Points.png
// module id = gODX
// module chunks = 0